import axios from "axios";

// Use environment variable for base URL
const API_URL = "https://ims.holdthechild.net"; // Update with your actual API URL

/**
 * Update user activation status
 * @param {string} id - ID of the user
 * @param {boolean} isActive - New activation status
 */
export async function updateUserStatus(id, isActive) {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.put(
      `${API_URL}/api/users/${id}/activation`,
      { isActive }, // Request body
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error updating user status:", error);
    throw error;
  }
}


// Fetch all users
export async function getAllUsers(page = 1, limit = 10, search = "") {
  try {
    const token = localStorage.getItem("token"); // Retrieve auth token if required
    console.log("Sending GET /api/users with token:", token);
    const response = await axios.get(`${API_URL}/api/users`, {
      params: { page, limit, search },  // <-- Send page, limit, and search
      headers: {
        Authorization: `Bearer ${token}`, // Attach token if backend requires authentication
      },
    });
    console.log("User fetch response:", response.data);
    return response.data; // Ensure backend returns a list of users
    // The response includes { users, totalUsers, page, totalPages, ... }
  } catch (error) {
    console.error("Error fetching users:", error?.response?.data || error.message);
    throw error;
  }
}

// DELETE /api/users/:id
export async function deleteUser(userId) {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.delete(`${API_URL}/api/staff/${userId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting user:", error);
    throw error;
  }
}

// Fetch user by ID
export const fetchCurrentUser = async (id) => {
  try {
    
    const token = localStorage.getItem("token");

    if (!token) throw new Error("No token found in localStorage");

    const res = await fetch(`https://ims.holdthechild.net/api/staff/${id}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      const errData = await res.json();
      console.error(" Server responded:", errData);
      throw new Error(errData.message || "Failed to fetch user");
    }

    const result = await res.json();
    if (result.success) {
      return result.data; // <-- return the user data here
    } else {
      throw new Error(result.message || "Failed to fetch user");
    }
  } catch (err) {
    console.error(" fetchCurrentUser error:", err.message);
    return null;
  }
};



